module.exports = __webpack_public_path__ + "img/worldwide.136490c6.png";